import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import "./SignUp.css"

export const SignupButton = () => {
  const { loginWithRedirect } = useAuth0();

  const handleSignUp = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: "/profile",
      },
      authorizationParams: {
        screen_hint: "signup",
      },
    });
  };

  return (
    <button className="SignUp-button" onClick={handleSignUp}>
      Sign Up
    </button>
  );
};